import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ModalComponent } from '../../../core/config/core.modal-helpers';
import { UiService } from '../../../core/services/core.ui.service';
import { ForumService } from '../forum.service';

@Component({
  selector: 'forum-delete-modal',
  template: require('./forum.delete.modal.html')
})
export class ForumDeleteModalComponent extends ModalComponent implements OnInit {
  @Input() forum: any;

  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(
    private forumService: ForumService,
    private uiService: UiService
  ) 
  { 
    super();
  }

  ngOnInit() {
  }

  doClose() {
    this.onClose.emit();
  }

  deleteForum() {
    this.forumService.deleteForum(this.forum.id)
    .then(() => {
      this.uiService.message.showSuccess("Discussion " + this.forum.forumName + " was deleted", "Delete Discussion");
      this.onDelete.emit({success: true});
    }, (response) => {
      console.log(response);
      this.uiService.message.showError("Sorry, could not delete Discussion " + this.forum.forumName, "Delete Discussion");
      this.onDelete.emit({success: false});
    });
  }
}

export default ForumDeleteModalComponent;